const initialState = {
  name: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_NAME':
      return {
        ...state,
        name: action.data,
      };

    default:
      return state;
  }
};
